export default [
  { code: 'ZAR', label: 'South African rand' },
  { code: 'USD', label: 'United States dollar' },
  { code: 'EUR', label: 'Euro' },

  { code: 'AFN', label: 'Afghan afghani' },
  { code: 'ALL', label: 'Albanian lek' },
  { code: 'DZD', label: 'Algerian dinar' },
  { code: 'AOA', label: 'Angolan kwanza' },
  { code: 'ARS', label: 'Argentine peso' },
  { code: 'AMD', label: 'Armenian dram' },
  { code: 'AWG', label: 'Aruban florin' },
  { code: 'AUD', label: 'Australian dollar' },
  { code: 'AZN', label: 'Azerbaijani manat' },
  { code: 'BSD', label: 'Bahamian dollar' },
  { code: 'BHD', label: 'Bahraini dinar' },
  { code: 'BDT', label: 'Bangladeshi taka' },
  { code: 'BBD', label: 'Barbados dollar' },
  { code: 'BYN', label: 'Belarusian ruble' },
  { code: 'BZD', label: 'Belize dollar' },
  { code: 'BMD', label: 'Bermudian dollar' },
  { code: 'BTN', label: 'Bhutanese ngultrum' },
  { code: 'BOB', label: 'Boliviano' },
  { code: 'BAM', label: 'Bosnia and Herzegovina convertible mark' },
  { code: 'BWP', label: 'Botswana pula' },
  { code: 'BRL', label: 'Brazilian real' },
  { code: 'BND', label: 'Brunei dollar' },
  { code: 'BGN', label: 'Bulgarian lev' },
  { code: 'BIF', label: 'Burundian franc' },
  { code: 'KHR', label: 'Cambodian riel' },
  { code: 'CAD', label: 'Canadian dollar' },
  { code: 'CVE', label: 'Cape Verdean escudo' },
  { code: 'KYD', label: 'Cayman Islands dollar' },
  { code: 'XAF', label: 'Central African CFA franc' },
  { code: 'XPF', label: 'CFP franc' },
  { code: 'CLP', label: 'Chilean peso' },
  { code: 'COP', label: 'Colombian peso' },
  { code: 'KMF', label: 'Comoro franc' },
  { code: 'CDF', label: 'Congolese franc' },
  { code: 'CRC', label: 'Costa Rican colon' },
  { code: 'HRK', label: 'Croatian kuna' },
  { code: 'CUC', label: 'Cuban convertible peso' },
  { code: 'CUP', label: 'Cuban peso' },
  { code: 'CZK', label: 'Czech koruna' },
  { code: 'DKK', label: 'Danish krone' },
  { code: 'DJF', label: 'Djiboutian franc' },
  { code: 'DOP', label: 'Dominican peso' },
  { code: 'XCD', label: 'East Caribbean dollar' },
  { code: 'EGP', label: 'Egyptian pound' },
  { code: 'ERN', label: 'Eritrean nakfa' },
  { code: 'ETB', label: 'Ethiopian birr' },
  { code: 'FKP', label: 'Falkland Islands pound' },
  { code: 'FJD', label: 'Fijian dollar' },
  { code: 'GMD', label: 'Gambian dalasi' },
  { code: 'GEL', label: 'Georgian lari' },
  { code: 'GHS', label: 'Ghanaian cedi' },
  { code: 'GIP', label: 'Gibraltar pound' },
  { code: 'XAU', label: 'Gold' },
  { code: 'GTQ', label: 'Guatemalan quetzal' },
  { code: 'GNF', label: 'Guinean franc' },
  { code: 'GYD', label: 'Guyanese dollar' },
  { code: 'HTG', label: 'Haitian gourde' },
  { code: 'HNL', label: 'Honduran lempira' },
  { code: 'HKD', label: 'Hong Kong dollar' },
  { code: 'HUF', label: 'Hungarian forint' },
  { code: 'ISK', label: 'Icelandic króna' },
  { code: 'INR', label: 'Indian rupee' },
  { code: 'IDR', label: 'Indonesian rupiah' },
  { code: 'IRR', label: 'Iranian rial' },
  { code: 'IQD', label: 'Iraqi dinar' },
  { code: 'ILS', label: 'Israeli new shekel' },
  { code: 'JMD', label: 'Jamaican dollar' },
  { code: 'JPY', label: 'Japanese yen' },
  { code: 'JOD', label: 'Jordanian dinar' },
  { code: 'KZT', label: 'Kazakhstani tenge' },
  { code: 'KES', label: 'Kenyan shilling' },
  { code: 'KWD', label: 'Kuwaiti dinar' },
  { code: 'KGS', label: 'Kyrgyzstani som' },
  { code: 'LAK', label: 'Lao kip' },
  { code: 'LBP', label: 'Lebanese pound' },
  { code: 'LSL', label: 'Lesotho loti' },
  { code: 'LRD', label: 'Liberian dollar' },
  { code: 'LYD', label: 'Libyan dinar' },
  { code: 'MOP', label: 'Macanese pataca' },
  { code: 'MKD', label: 'Macedonian denar' },
  { code: 'MGA', label: 'Malagasy ariary' },
  { code: 'MWK', label: 'Malawian kwacha' },
  { code: 'MYR', label: 'Malaysian ringgit' },
  { code: 'MVR', label: 'Maldivian rufiyaa' },
  { code: 'MUR', label: 'Mauritian rupee' },
  { code: 'MXN', label: 'Mexican peso' },
  { code: 'MDL', label: 'Moldovan leu' },
  { code: 'MNT', label: 'Mongolian tögrög' },
  { code: 'MAD', label: 'Moroccan dirham' },
  { code: 'MZN', label: 'Mozambican metical' },
  { code: 'MMK', label: 'Myanmar kyat' },
  { code: 'NAD', label: 'Namibian dollar' },
  { code: 'NPR', label: 'Nepalese rupee' },
  { code: 'ANG', label: 'Netherlands Antillean guilder' },
  { code: 'TWD', label: 'New Taiwan dollar' },
  { code: 'NZD', label: 'New Zealand dollar' },
  { code: 'NIO', label: 'Nicaraguan córdoba' },
  { code: 'NGN', label: 'Nigerian naira' },
  { code: 'KPW', label: 'North Korean won' },
  { code: 'NOK', label: 'Norwegian krone' },
  { code: 'OMR', label: 'Omani rial' },
  { code: 'PKR', label: 'Pakistani rupee' },
  { code: 'XPD', label: 'Palladium' },
  { code: 'PAB', label: 'Panamanian balboa' },
  { code: 'PGK', label: 'Papua New Guinean kina' },
  { code: 'PYG', label: 'Paraguayan guaraní' },
  { code: 'PEN', label: 'Peruvian sol' },
  { code: 'PHP', label: 'Philippine peso' },
  { code: 'XPT', label: 'Platinum' },
  { code: 'PLN', label: 'Polish złoty' },
  { code: 'GBP', label: 'Pound sterling' },
  { code: 'QAR', label: 'Qatari riyal' },
  { code: 'CNY', label: 'Renminbi' },
  { code: 'RON', label: 'Romanian leu' },
  { code: 'RUB', label: 'Russian ruble' },
  { code: 'RWF', label: 'Rwandan franc' },
  { code: 'SHP', label: 'Saint Helena pound' },
  { code: 'SVC', label: 'Salvadoran colón' },
  { code: 'WST', label: 'Samoan tala' },
  { code: 'SAR', label: 'Saudi riyal' },
  { code: 'RSD', label: 'Serbian dinar' },
  { code: 'SCR', label: 'Seychelles rupee' },
  { code: 'SLL', label: 'Sierra Leonean leone' },
  { code: 'XAG', label: 'Silver' },
  { code: 'SGD', label: 'Singapore dollar' },
  { code: 'SBD', label: 'Solomon Islands dollar' },
  { code: 'SOS', label: 'Somali shilling' },
  { code: 'KRW', label: 'South Korean won' },
  { code: 'SSP', label: 'South Sudanese pound' },
  { code: 'XDR', label: 'Special drawing rights' },
  { code: 'LKR', label: 'Sri Lankan rupee' },
  { code: 'SDG', label: 'Sudanese pound' },
  { code: 'SRD', label: 'Surinamese dollar' },
  { code: 'SZL', label: 'Swazi lilangeni' },
  { code: 'SEK', label: 'Swedish krona' },
  { code: 'CHF', label: 'Swiss franc' },
  { code: 'SYP', label: 'Syrian pound' },
  { code: 'TJS', label: 'Tajikistani somoni' },
  { code: 'TZS', label: 'Tanzanian shilling' },
  { code: 'THB', label: 'Thai baht' },
  { code: 'TOP', label: 'Tongan paʻanga' },
  { code: 'TTD', label: 'Trinidad and Tobago dollar' },
  { code: 'TND', label: 'Tunisian dinar' },
  { code: 'TRY', label: 'Turkish lira' },
  { code: 'TMT', label: 'Turkmenistan manat' },
  { code: 'UGX', label: 'Ugandan shilling' },
  { code: 'UAH', label: 'Ukrainian hryvnia' },
  { code: 'CLF', label: 'Unidad de Fomento' },
  { code: 'AED', label: 'United Arab Emirates dirham' },
  { code: 'UYU', label: 'Uruguayan peso' },
  { code: 'UZS', label: 'Uzbekistan som' },
  { code: 'VUV', label: 'Vanuatu vatu' },
  { code: 'VES', label: 'Venezuelan bolívar' },
  { code: 'VND', label: 'Vietnamese đồng' },
  { code: 'XOF', label: 'West African CFA franc' },
  { code: 'YER', label: 'Yemeni rial' },
  { code: 'ZMW', label: 'Zambian kwacha' },
  { code: 'ZWL', label: 'Zimbabwean dolla' }
];
